import { ColoursObj, Typography } from '@eventr/common-storybook'
import { Box, Checkbox } from '@mui/material'
import { cardTranslation } from '../../../i18n/translateHelpers'
interface ITickListItem {
    label: string
    completed: boolean
    [key: string]: any
}
interface ITickListProps {
    tickList: ITickListItem[]
    onClick: (item: any) => void
    disabled?: boolean
}
export const TickList = ({ tickList, onClick, disabled }: ITickListProps) => {
    return (
        <Box display={'grid'} gridTemplateColumns={'auto'} gap={'12px'}>
            {tickList.map((item, index) => (
                <Box
                    key={index}
                    display={'grid'}
                    gridTemplateColumns={'auto 1fr'}
                    gap={'8px'}
                    alignItems={'start'}
                    onClick={() => {
                        if (disabled) return

                        if (onClick) {
                            onClick(item)
                        }
                    }}
                >
                    <Checkbox
                        sx={{ color: ColoursObj.core.primary }}
                        disabled={disabled}
                        style={{ padding: '0px' }}
                        checked={item.completed}
                    />
                    <Typography>{item.label}</Typography>
                </Box>
            ))}
            <Typography variant="bodyBold">
                {cardTranslation('Completed')}{' '}
                {tickList.filter((item) => item.completed).length}/
                {tickList.length}
            </Typography>
        </Box>
    )
}
